import { useSyncExternalStore } from 'react';

/** Phone breakpoint: everything below Tailwind `md` (768px). */
export const PHONE_MEDIA_QUERY = '(max-width: 767px)';

const getMql = (): MediaQueryList | null =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(PHONE_MEDIA_QUERY)
        : null;

const subscribe = (onChange: () => void) => {
    const mql = getMql();
    if (!mql) return () => undefined;
    if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }
    // Safari < 14
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
};

const getSnapshot = () => getMql()?.matches ?? false;
// SSR / jsdom without matchMedia: render the md+ tree.
const getServerSnapshot = () => false;

/**
 * True below md (<768px). Use ONLY when a phone needs a different component
 * tree; for pure styling prefer `md:hidden` / `hidden md:block`. SSR and
 * test safe: returns false when matchMedia is unavailable.
 */
export function useIsPhone(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
